<template>
  <div class="redirect-login">
    <h1><img class="menu__logo" src="@/assets/isologo.svg" alt="fanfest"/></h1>
    <h2>{{$t("redirectlogin.title")}} <span>.</span><span>.</span><span>.</span></h2>
  </div>
</template>

<script>
import PersistentData from '@/plugins/persistentData'

export default {
  async mounted() {
    const token = window.location.hash.split('&')[0].split('=')[1]
    const request = await this.$store.dispatch('authenticateFacebook' , {
      accessToken: token,
      registrationKey: ''
    })
    if (request.status == 200) {
      PersistentData.setData('fullName', `${request.data.firstName} ${request.data.lastName}`)
      PersistentData.setData('token', request.data.token)
      PersistentData.setData('tokenExpiration', request.data.tokenExpiration)
      window.close()
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/_variables';

.redirect-login {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: 100vh;

    h1 {
        img {
            width: 200px;
            height: 200px;
            margin-bottom: $margin-kilo;
        }
    }

    h2 {
      color: $white;
      @include font-settings(base,base);

      span {
          animation-name: blink;
          animation-duration: 1.4s;
          animation-iteration-count: infinite;
          animation-fill-mode: both;
      
          &:nth-child(2) {
              animation-delay: .2s;
          }
          
          &:nth-child(3) {
              animation-delay: .4s;
          }
          
        }
        
        @keyframes blink {
          0% {
            opacity: .2;
          }
          20% {
            opacity: 1;
          }
          100% {
            opacity: .2;
          }
        }
    }
}
</style>